import React from 'react';

import styled from 'styled-components';

const ModalBackground = styled.div`
  user-select: none;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.4);
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  display: flex;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: fixed;
`;

const ModalContainer = styled.div<{ isFull: boolean }>`
  padding: ${({ isFull }) => (isFull ? '0' : '1rem')};
  max-width: max-content;
  width: 100%;
  height: ${({ isFull }) => (isFull ? '100%' : 'auto')};
  margin: auto;
  position: relative;
`;

const ModalOutline = styled.div<{
  noPadding?: boolean;
  maxWidth?: string;
  isFull: boolean;
  modalOutlineMinWidth?: string;
}>`
  min-width: ${(props) => props.modalOutlineMinWidth} || '300px';
  max-width: ${(props) => props.maxWidth};
  height: ${(props) => (props.isFull ? '100vh' : 'auto')};
  background-color: white;
  border-radius: 4px;
  padding: ${(props) => (props.noPadding ? '40px 0 0 0' : '40px 24px 24px 24px')};
  position: relative;
`;

const ModalCloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  width: 48px;
  height: 48px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
`;

type Props = {
  cancellable: boolean;
  open: boolean;
  children: React.ReactNode;
  onClose: () => void;
  noPadding?: boolean;
  maxWidth?: string;
  isFull?: boolean;
  modalOutlineMinWidth?: string;
};

export const Modal: React.FC<Props> = (props) => {
  const {
    cancellable,
    open,
    children,
    noPadding = false,
    onClose,
    maxWidth = 'none',
    isFull = false,
    modalOutlineMinWidth,
  } = props;

  return (
    <>
      {open ? (
        <ModalBackground tabIndex={-1} onClick={() => cancellable && onClose()}>
          <ModalContainer isFull={isFull} className="modal-container" onClick={(e) => e.stopPropagation()}>
            <ModalOutline
              className="modal-outline"
              noPadding={noPadding}
              maxWidth={maxWidth}
              isFull={isFull}
              modalOutlineMinWidth={modalOutlineMinWidth}
            >
              {cancellable ? (
                <ModalCloseButton onClick={onClose}>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 13L7 7.05505L1 1" stroke="#A3A7AE" strokeWidth="2" />
                    <path d="M13 0.999999L7 6.94495L13 13" stroke="#A3A7AE" strokeWidth="2" />
                  </svg>
                </ModalCloseButton>
              ) : null}
              {children}
            </ModalOutline>
          </ModalContainer>
        </ModalBackground>
      ) : null}
    </>
  );
};
